/*
  Der Kaufbereich zeigt ein Skelett, bis er vollstaendig steht — Titel, Preis, Sorten, Knopf
  auf einmal statt nach und nach.

  Warum ueberhaupt: Das Markup kommt fertig vom Server, aber zwei Dinge brauchen noch das
  Skript. Die Sortenauswahl ist bis dahin ein gewoehnliches Auswahlfeld, und der Aktionspreis
  wird erst gerechnet. Auf einer schnellen Leitung sieht das niemand; auf einer langsamen baut
  sich der Bereich sichtbar in Etappen auf.

  Warum es trotzdem nichts kostet: Das groesste Element der Seite (LCP) ist das Produktbild in
  der Galerie, nicht der Kaufbereich — gemessen ueber fuenf Laeufe, Median 1484 ms. Die Galerie
  bleibt unberuehrt, die Kennzahl also auch.

  Und warum es auf einer schnellen Leitung nicht aufblitzt: Das Skelett blendet sich erst nach
  einer kurzen Verzoegerung ein (CSS). Ist der Bereich vorher fertig — der Normalfall —, war es
  nie zu sehen. Ein Skelett, das 50 ms aufblitzt, ist schlechter als gar keines.
*/

/* Laenger wartet niemand auf ein Skript: Danach wird der Bereich gezeigt, wie er ist. */
const GEDULD = 3000;

function fertig(bereich) {
  bereich.dataset.wartet = 'false';
}

async function warten(bereich) {
  const notbremse = window.setTimeout(() => fertig(bereich), GEDULD);
  try {
    await Promise.all([
      customElements.whenDefined('kg-product-form'),
      bereich.querySelector('kg-select') ? customElements.whenDefined('kg-select') : null,
      bereich.querySelector('kg-product-promo') ? customElements.whenDefined('kg-product-promo') : null,
    ]);
    /*
      Ein Bild abwarten: `whenDefined` sagt nur, dass die Komponente bekannt ist — gezeichnet
      hat sie dann noch nichts. Ohne die Pause faellt das Skelett eine Haaresbreite zu frueh.
    */
    await new Promise((r) => window.requestAnimationFrame(() => window.requestAnimationFrame(r)));
  } catch {
    /* Faellt ein Skript aus, soll der Bereich trotzdem erscheinen. */
  }
  window.clearTimeout(notbremse);
  fertig(bereich);
}

function wartende() {
  return document.querySelectorAll('.product-info[data-wartet="true"]');
}

wartende().forEach(warten);

/*
  Der Groessenwechsel ist ein Wechsel des Listings: Das Markup kommt frisch vom Server und
  traegt das Skelett erneut. Die Abfrage oben lief aber nur ein Mal, beim Laden des Moduls —
  ohne diese Zeile schimmerte der Kaufbereich nach jedem Groessenwechsel fuer immer weiter.

  Hier wird nicht gewartet, sondern sofort freigegeben: Die Skripte stehen zu diesem Zeitpunkt
  laengst, und ein Bild Verzoegerung waere ein sichtbares Flackern mitten in einem Wechsel,
  bei dem der Kunde gar nicht merken soll, dass die Seite gewechselt hat.
*/
document.addEventListener('page:replaced', () => wartende().forEach(fertig));
